/**
* Copyright (C), 2012-2019, Sichuan Xiaoka Technology Co., Ltd.
* name: 公共组件-标签页
* */
<template>
  <div id="tabs">
    <div class="tabs-active-style" :style="{'width': width + 'px'}" id="tabs-active-style"><span></span></div>
    <ul class="boss-tabs">
      <li class="boss-tabs-item" v-for="(item, index) in tabs"
          :key="index"
          :class="{'tabs-item-active': value === item.active}"
          @touchstart="touchstartFn(item.active, index)"
          @click="touchstartFn(item.active, index)">
        <i v-if="item.icon" class="boss" :class="item.icon"></i>
        <span class="boss-tabs-item-span">{{item.name}}</span>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: 'tabs',
    props: {
      tabs: { // tabs项
        default () {
          return []
        }
      },
      active: { // 当前激活的菜单
        default () {
          return ''
        }
      }
    },
    data () {
      return {
        value: this.active,
        width: ''
      }
    },
    watch: {
      active (val) { // 激活的菜单变化,相应的样式也发生变化
        this.value = val
        console.log('激活的菜单变化', val)
        let index = this.tabs.findIndex(value => value.active === val)
        this.lineStyleFn(index)
      }
    },
    methods: {
      touchstartFn (active, index) { // tab项点击事件
        this.value = active
        this.$emit('update:active', active)
        this.$emit('activeFn', active)
        this.lineStyleFn(index)
      },
      lineStyleFn (index) { // 底部线条的动画效果
        let oStyle = document.getElementById('tabs-active-style')
        let oSpan = document.getElementById('tabs-active-style').getElementsByTagName('span')[0]
        let oStyleSpan = document.getElementsByClassName('boss-tabs-item-span')[index]
        oSpan.style.width = oStyleSpan.offsetWidth ? oStyleSpan.offsetWidth + 'px' : ''
        let dis = this.width * index
        oStyle.style.transform = 'translateX(' + dis + 'px)'
      },
      touchLeftRight (el) { // 判断向左向右滑动--移动端touch事件
        let startX = 0
        let startY = 0
        let endX = 0
        let endY = 0
        el.ontouchstart = (e) => {
          startX = e.touches[0].clientX
          startY = e.touches[0].clientY
        }
        el.ontouchend = (e) => {
          endX = e.changedTouches[0].clientX
          endY = e.changedTouches[0].clientY
          let index = this.tabs.findIndex(value => value.active === this.active)
          let x = endX - startX
          // let y = endY - startY
          let tan = Math.abs(endY - startY) / Math.abs(endX - startX)
          let a = Math.atan(tan) * (180 / Math.PI)
          if (Math.abs(endX - startX) > 10) { // 移动距离小于10，视为只是点击事件
            if (a < 30) {
              if (x < 0) { // 手势向左滑动+1
                let len = this.tabs.length - 1
                if (index < len) { // 已经是最后一个了就不再变化
                  this.value = this.tabs[index + 1].active
                  this.$emit('update:active', this.value)
                  this.$emit('activeFn', this.value)
                }
              }
              if (x > 0) { // 手势向右滑动-1
                if (index > 0) { // 已经是第一个了就不再变化
                  this.value = this.tabs[index - 1].active
                  this.$emit('update:active', this.value)
                  this.$emit('activeFn', this.value)
                }
              }
            }
          }
        }
      }
    },
    mounted () {
      this.$nextTick(() => {
        console.log(this.$el.parentNode)
        let oUl = document.getElementsByTagName('ul')[0]
        this.width = oUl.offsetWidth / this.tabs.length
        let index = this.tabs.findIndex(value => value.active === this.active)
        this.lineStyleFn(index)
        let el = this.$el.parentNode // 获取使用tab元素的父级元素
        this.touchLeftRight(el)
      })
    }
  }
</script>

<style lang="less">
  #tabs {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background-color: #FFFFFF;
    .tabs-active-style{
      position: absolute;
      left: 0;
      bottom: 0;
      height: 2px;
      background-color: transparent;
      z-index: 1;
      transition: all .2s;
      transform: translateX(0px);
      span{
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        height: 2px;
        background-color: #EA6550;
      }
    }
    .boss-tabs{
      display: flex;
      .boss-tabs-item{
        height: 44px;
        flex: 1 0;
        text-align: center;
        font-size: 14px;
        .boss-tabs-item-span{
          display: inline-block;
          line-height: 44px;
          /*padding-top: 16px;*/
          font-weight: 500;
        }
      }
      .tabs-item-active{
        // border-bottom-color: $theme_color;
        .boss-tabs-item-span{
          color: #EA6550;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// tabs.vue?1734a4ce